import React, { Component } from "react";
import Grid from '@material-ui/core/Grid';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Plus from "mdi-material-ui/Plus";
import TitleBar from "../../components/TitleBar";
import TitleBarTitle from "../../components/TitleBarTitle";
import TableCellLink from "../../components/TableCellLink";
import TitleBarButton from "../../components/TitleBarButton";
import Admin from "../../components/Admin";
import DataTable from "../../components/DataTable";
import ServiceProfileStore from "../../stores/ServiceProfileStore";
import {withStyles} from "@material-ui/core/styles";
import { tableSortStyles, bindTableSortHandlers } from "../../classes/tableSort";
import Check from "mdi-material-ui/Check";
import Close from "mdi-material-ui/Close";
import OrganizationBreadcrumps from "../../components/OrganizationBreadcrumps";


const styles ={
  tableRow:{ backgroundColor: "#f0f0f0"},
  ...tableSortStyles,
};

class ListServiceProfiles extends Component {
  constructor() {
    super();

    this.getPage = this.getPage.bind(this);
    this.getRow = this.getRow.bind(this);
    bindTableSortHandlers(this);

    this.state = {
        orderBy:null,
        order:null
    }
  }

  getPage(limit, offset, callbackFunc) {
    ServiceProfileStore.list(this.props.match.params.organizationID, 0, limit, offset, callbackFunc, this.state.orderBy, this.state.order);
  }

  getRow(obj) {

    return(
      <TableRow
      className={obj.isDisabled && this.props.classes.tableRow}
      hover={!obj.isDisabled}
        key={obj.id}>
        <TableCellLink to={`/organizations/${this.props.match.params.organizationID}/service-profiles/${obj.id}`}>{obj.name}</TableCellLink>
        <TableCell>{obj.id}</TableCell>
        <TableCell>{obj.deviceCountLimit}</TableCell>
        <TableCellLink to={`/organizations/${this.props.match.params.organizationID}/devices/?sp=${obj.id}`}>{obj.usedDevicesCount}</TableCellLink>
        <TableCell>{obj.availableDevicesCount}</TableCell>
        <TableCell>{obj.networkServerName}</TableCell>
        <TableCell>{obj.isDisabled ? <Close /> : <Check />}</TableCell>
      </TableRow>
    );
  }
 
  render() {
    
    return(
      <Grid container spacing={4}>
        <TitleBar
          buttons={
            <Admin>
              <TitleBarButton
                label="Create"
                icon={<Plus />}
                to={`/organizations/${this.props.match.params.organizationID}/service-profiles/create`}
              />
            </Admin>
          }
        >
          <OrganizationBreadcrumps org={this.props.org}>
             <TitleBarTitle title="Service-profiles" />
          </OrganizationBreadcrumps>
         
          
        </TitleBar>
        <Grid item xs={12}>
          <DataTable
          orderBy={this.state.orderBy}
          order={this.state.order}
            header={
              <TableRow>
                <TableCell  {...this.makeCellSortProps('name')}>
                  {this.makeSortLabel('name','Name')}
                </TableCell>
                <TableCell {...this.makeCellSortProps('id')} >{this.makeSortLabel('id','ID')}</TableCell>
                <TableCell>Max number of devices</TableCell>
                <TableCell>The used number of devices</TableCell>
                <TableCell>Available number of devices</TableCell>
                <TableCell{...this.makeCellSortProps('networkServerName')} >{this.makeSortLabel('networkServerName','Frequency plan')}</TableCell>
                <TableCell>Active</TableCell>
              </TableRow>
            }
            getPage={this.getPage}
            getRow={this.getRow}
          />
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(ListServiceProfiles);
